import VideoController from './videoController';

export default VideoController;
